import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-brand px-5 py-14" data-id="element-90" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-91" data-mp="32num8qaq072f">
        <p className="font-display text-2xl font-black uppercase tracking-tight text-white" data-id="element-92" data-mp="32pffmclatjyp">
          Tennis <span className="text-lime" data-id="element-93" data-mp="36pzaf9iegbho">Ready</span>
          <span className="align-super text-xs" data-id="element-94" data-mp="3ufa5qbgzddof">™</span>
        </p>
        <p className="mt-2 text-xs font-semibold uppercase tracking-[0.18em] text-lime" data-id="element-95" data-mp="3ucxo5zf4x5bw">
          Less Planning. More Coaching. Better Results.
        </p>
        <nav aria-label="Footer" data-id="element-96" data-mp="3ldalzbekzvhs">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/60" data-id="element-97" data-mp="3le2l2w7e0bct">
            {links.map(link => <li key={link} data-id="element-98" data-mp="29y5gy0qz9kv0">
                <a href="#offer" className="transition-colors hover:text-lime" data-id="element-99" data-mp="29xvrqfdrbhqd">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/40" data-id="element-100" data-mp="3labt60db0esh">
          © 2026 Tennis Ready. All Rights Reserved.
        </p>
      </div>
    </footer>;
}